import { render, staticRenderFns } from "./FeedbackSummaryItem.vue?vue&type=template&id=decbf95a&scoped=true&"
import script from "./FeedbackSummaryItem.vue?vue&type=script&lang=js&"
export * from "./FeedbackSummaryItem.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackSummaryItem.vue?vue&type=style&index=0&id=decbf95a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decbf95a",
  null
  
)

export default component.exports